/**
 * Stock List Page - N6 AI Trading Platform
 */

document.addEventListener('DOMContentLoaded', function() {
  const tableBody = document.getElementById('stockTableBody');

  const stockColors = {
    AAPL: '#555555',
    MSFT: '#737373',
    NVDA: '#76B900',
    AMZN: '#FF9900',
    GOOGL: '#4285F4',
    META: '#0082FB',
    TSLA: '#CC0000',
    JPM: '#003A70',
    V: '#1A1F71',
    NFLX: '#E50914',
    DIS: '#0057A8',
    PYPL: '#003087',
    AMD: '#000000',
    INTC: '#0071C5',
    CRM: '#00A1E0',
    ORCL: '#F80000',
    ADBE: '#FF0000',
    CSCO: '#1BA0D7',
    PEP: '#004B93',
    KO: '#F40009',
    WMT: '#0071CE',
    PFE: '#0093D0',
    JNJ: '#D51900',
    XOM: '#ED1B2F',
    BAC: '#E31837',
    GS: '#7399C6',
    MS: '#002B5C',
    NKE: '#111111',
    MCD: '#FFC72C',
    UNH: '#002677',
    HD: '#F96302',
    CVX: '#0054A4',
    ABBV: '#071D49',
    T: '#00A8E0',
    VZ: '#CD040B',
    QCOM: '#3253DC',
    TXN: '#CC0000',
    COST: '#E31837',
    SBUX: '#00704A',
    BMY: '#721B65',
    AVGO: '#CC092F'
  };

  function getStockFromRow(row) {
    var ticker = row.getAttribute('data-ticker') || '';
    var name = row.getAttribute('data-name') || '';
    var price = parseFloat(row.getAttribute('data-price') || '0');
    var ai = parseFloat(row.getAttribute('data-ai') || '0');
    return { ticker: ticker, name: name, price: price, ai: ai };
  }

  function mulberry32(seed) {
    var t = seed >>> 0;
    return function() {
      t += 0x6D2B79F5;
      var r = Math.imul(t ^ (t >>> 15), 1 | t);
      r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }

  function hashSeed(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0;
    }
    return h >>> 0;
  }

  function drawStaticSparklines() {
    var canvases = document.querySelectorAll('.graph-canvas');
    canvases.forEach(function(canvas) {
      var seed = canvas.getAttribute('data-seed') || Math.random().toString();
      var rand = mulberry32(hashSeed(seed));
      var ctx = canvas.getContext('2d');
      if (!ctx) return;

      var rect = canvas.getBoundingClientRect();
      var width = Math.max(1, Math.round(rect.width || 140));
      var height = Math.max(1, Math.round(rect.height || 40));
      canvas.width = width;
      canvas.height = height;

      var points = [];
      var value = 0.5;
      var steps = 14;
      for (var i = 0; i < steps; i++) {
        value += (rand() - 0.48) * 0.18;
        value = Math.max(0.1, Math.min(0.9, value));
        points.push(value);
      }

      ctx.clearRect(0, 0, width, height);
      ctx.lineWidth = 2;
      ctx.strokeStyle = 'rgba(34, 197, 94, 0.95)';
      ctx.beginPath();
      points.forEach(function(v, i) {
        var x = (i / (steps - 1)) * width;
        var y = height - v * height;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      });
      ctx.stroke();

      var grad = ctx.createLinearGradient(0, 0, 0, height);
      grad.addColorStop(0, 'rgba(34, 197, 94, 0.18)');
      grad.addColorStop(1, 'rgba(34, 197, 94, 0)');
      ctx.lineTo(width, height);
      ctx.lineTo(0, height);
      ctx.closePath();
      ctx.fillStyle = grad;
      ctx.fill();
    });
  }

  if (tableBody) {
    drawStaticSparklines();
    window.addEventListener('resize', function() {
      drawStaticSparklines();
    });
  }

  // ============================================
  // TRADE MODAL
  // ============================================
  var modal = document.getElementById('tradeModal');
  var modalCloseBtn = document.getElementById('tradeModalClose');
  var modalOverlay = modal ? modal.querySelector('.trade-modal__overlay') : null;
  var modalTabs = modal ? modal.querySelectorAll('.trade-modal__tab') : [];
  var tabManual = document.getElementById('tabManual');
  var tabAuto = document.getElementById('tabAuto');
  var tradeChart = null;
  var currentTradeStock = null;
  var currentTradePeriod = '1w';
  var tradeSeriesCache = {};

  function openModal(stock) {
    if (!modal) return;
    var bgColor = stockColors[stock.ticker] || '#666';

    // Manual tab
    var manualLogo = document.getElementById('modalManualLogo');
    manualLogo.style.backgroundColor = bgColor;
    manualLogo.textContent = stock.ticker.charAt(0);
    document.getElementById('modalManualTicker').textContent = stock.ticker;
    document.getElementById('modalManualName').textContent = stock.name;
    document.getElementById('modalManualPrice').textContent = '$' + stock.price.toFixed(2);
    document.getElementById('modalAvgPrice').textContent = '$' + stock.price.toFixed(2);

    // Auto tab
    var autoLogo = document.getElementById('modalAutoLogo');
    autoLogo.style.backgroundColor = bgColor;
    autoLogo.textContent = stock.ticker.charAt(0);
    document.getElementById('modalAutoTicker').textContent = stock.ticker;
    document.getElementById('modalAutoName').textContent = stock.name;

    // AI score
    document.getElementById('modalAiValue').textContent = stock.ai + '%';
    document.getElementById('modalAiScore2').textContent = stock.ai + '%';

    // AI circle color
    var aiCircle = document.getElementById('modalAiCircle');
    if (stock.ai >= 80) aiCircle.style.backgroundColor = '#22C55E';
    else if (stock.ai >= 60) aiCircle.style.backgroundColor = '#F59E0B';
    else aiCircle.style.backgroundColor = '#EF4444';

    // Reset to manual tab
    modalTabs.forEach(function(t) { t.classList.remove('is-active'); });
    modalTabs[0].classList.add('is-active');
    tabManual.classList.remove('is-hidden');
    tabAuto.classList.add('is-hidden');

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    currentTradeStock = stock;
    var activePeriod = modal.querySelector('.trade-modal__period.is-active');
    currentTradePeriod = activePeriod ? activePeriod.getAttribute('data-period') : '1w';
    renderTradeChart(stock, currentTradePeriod);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    if (tradeChart) { tradeChart.destroy(); tradeChart = null; }
    currentTradeStock = null;
  }

  function getPeriodConfig(period) {
    switch (period) {
      case '1d': return { length: 24, labels: 'hours', volatility: 0.004 };
      case '1m': return { length: 30, labels: 'days', volatility: 0.008 };
      case '3m': return { length: 60, labels: 'weeks', volatility: 0.011 };
      case '1y': return { length: 120, labels: 'months', volatility: 0.014 };
      case '1w':
      default: return { length: 30, labels: 'weekdays', volatility: 0.006 };
    }
  }

  function mulberry32(seed) {
    var t = seed >>> 0;
    return function() {
      t += 0x6D2B79F5;
      var r = Math.imul(t ^ (t >>> 15), 1 | t);
      r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }

  function hashSeed(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0;
    }
    return h >>> 0;
  }

  function buildLabels(length, mode) {
    if (mode === 'hours') {
      var hours = [];
      for (var i = 0; i < length; i++) hours.push((i + 1) + 'h');
      return hours;
    }
    if (mode === 'weekdays') {
      var labels = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
      var week = [];
      for (var j = 0; j < length; j++) week.push(labels[j % 7]);
      return week;
    }
    if (mode === 'weeks') {
      var weeks = [];
      var totalWeeks = Math.max(1, Math.ceil(length / 5));
      for (var k = 0; k < length; k++) {
        var w = Math.floor(k / 5) + 1;
        weeks.push('W' + w);
      }
      return weeks;
    }
    if (mode === 'months') {
      var months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
      var out = [];
      for (var m = 0; m < length; m++) out.push(months[m % 12]);
      return out;
    }
    var days = [];
    for (var d = 0; d < length; d++) days.push((d + 1).toString());
    return days;
  }

  function getTradeSeries(stock, period) {
    if (!tradeSeriesCache[stock.ticker]) tradeSeriesCache[stock.ticker] = {};
    if (tradeSeriesCache[stock.ticker][period]) return tradeSeriesCache[stock.ticker][period];

    var cfg = getPeriodConfig(period);
    var seed = hashSeed(stock.ticker + ':' + period);
    var rand = mulberry32(seed);
    var series = [];
    var base = stock.price * (0.85 + rand() * 0.08);
    for (var i = 0; i < cfg.length; i++) {
      base += (rand() - 0.48) * (stock.price * cfg.volatility);
      series.push(Math.round(base * 100) / 100);
    }
    series[series.length - 1] = stock.price;

    var result = { data: series, labels: buildLabels(cfg.length, cfg.labels) };
    tradeSeriesCache[stock.ticker][period] = result;
    return result;
  }

  function renderTradeChart(stock, period) {
    if (typeof Chart === 'undefined') return;
    var canvas = document.getElementById('tradeModalChart');
    if (!canvas) return;
    if (tradeChart) { tradeChart.destroy(); tradeChart = null; }

    var isDark = document.body.classList.contains('theme-dark');
    var lineColor = '#22C55E';
    var gridColor = isDark ? 'rgba(255,255,255,0.08)' : '#E5E7EB';
    var textColor = isDark ? '#9CA3AF' : '#6B7280';

    var series = getTradeSeries(stock, period);

    var ctx = canvas.getContext('2d');
    var gradient = ctx.createLinearGradient(0, 0, 0, 200);
    gradient.addColorStop(0, 'rgba(34, 197, 94, 0.2)');
    gradient.addColorStop(1, 'rgba(34, 197, 94, 0)');

    tradeChart = new Chart(canvas, {
      type: 'line',
      data: {
        labels: series.labels,
        datasets: [{
          data: series.data,
          borderColor: lineColor,
          backgroundColor: gradient,
          fill: true,
          tension: 0.1,
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 4,
          pointHoverBackgroundColor: lineColor,
          pointHoverBorderColor: '#fff',
          pointHoverBorderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function(c) { return '$' + c.parsed.y.toFixed(2); }
            }
          }
        },
        scales: {
          x: {
            display: true,
            grid: { display: false },
            ticks: {
              color: textColor,
              font: { size: 10 },
              maxTicksLimit: 7
            }
          },
          y: {
            display: true,
            grid: { color: gridColor },
            ticks: {
              color: textColor,
              font: { size: 10 },
              callback: function(v) { return '$' + v; }
            }
          }
        }
      }
    });
  }

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', closeModal);
  }
  if (modalOverlay) {
    modalOverlay.addEventListener('click', closeModal);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  modalTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      modalTabs.forEach(function(t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var target = tab.getAttribute('data-tab');
      if (target === 'manual') {
        tabManual.classList.remove('is-hidden');
        tabAuto.classList.add('is-hidden');
      } else {
        tabManual.classList.add('is-hidden');
        tabAuto.classList.remove('is-hidden');
      }
    });
  });

  // Period tabs
  var periodTabs = modal ? modal.querySelectorAll('.trade-modal__period') : [];
  periodTabs.forEach(function(pt) {
    pt.addEventListener('click', function() {
      periodTabs.forEach(function(t) { t.classList.remove('is-active'); });
      pt.classList.add('is-active');
      if (currentTradeStock) {
        currentTradePeriod = pt.getAttribute('data-period') || '1w';
        renderTradeChart(currentTradeStock, currentTradePeriod);
      }
    });
  });

  // Delegate click on TRADE buttons
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.stock-table__trade-btn');
    if (!btn) return;

    var row = btn.closest('tr');
    if (!row) return;

    var stock = getStockFromRow(row);
    if (stock && stock.ticker) openModal(stock);
  });

  if (!tableBody && !modal) return;
});
